// generated by genversion
const version = '6.13.4';

export { version };
//# sourceMappingURL=version.mjs.map
